import { createSelector } from '@opengov/compose-app/reselect';
import { IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';
import { createAgGridColumnConfig } from '@opengov/reporting-types';

import {
  selectDetailTableColumns,
  selectHiddenColumnsFromDataMgr,
  selectReportConfigWithMetadata
} from '../../reportExplorer/selectors/selectReportExplorerState';

export const selectVisibleDetailTableColumns = createSelector(
  selectDetailTableColumns,
  selectHiddenColumnsFromDataMgr,
  (columns: IReportColumn[], hiddenColumns: string[]): IReportColumn[] => {
    return columns && columns.filter((c) => !hiddenColumns.includes(c.name));
  }
);

export const selectVisibleDetailTableColumnDisplayNames = createSelector(
  selectVisibleDetailTableColumns,
  (visibleColumns: IReportColumn[]): string[] => visibleColumns && visibleColumns.map((c) => c.displayName)
);

export const selectAgGridColumnConfig = createSelector(
  selectReportConfigWithMetadata,
  selectVisibleDetailTableColumns,
  (reportConfiguration, visibleCols) => {
    if (!reportConfiguration) return;
    if (reportConfiguration?.presentationConfiguration?.agGridColumnConfig) {
      return reportConfiguration.presentationConfiguration.agGridColumnConfig.map(createAgGridColumnConfig);
    }
    return visibleCols.map((col, index) =>
      createAgGridColumnConfig({
        columnName: col.name,
        pinned: null,
        sortedIndex: index,
        hide: false
      })
    );
  }
);
